// src/EditCommanderModal.js
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axiosInstance from '../utils/axiosInstance';
import { API_URL } from '../utils/runtimeConfig';
import './css/EditCommanderModal.css';

const apiUrl = API_URL

const EditCommanderModal = ({ isOpen, onRequestClose, commander, onCommanderUpdated }) => {
  const axios = axiosInstance
  const getNationId = (nationValue) => {
    if (!nationValue) return '';
    if (typeof nationValue === 'object') {
      return String(nationValue._id || nationValue.id || '');
    }
    return String(nationValue);
  };

  const [name, setName] = useState('');
  const [rank, setRank] = useState('');
  const [battlePower, setBattlePower] = useState('');
  const [alliance, setAlliance] = useState('');
  const [cityLevel, setCityLevel] = useState('');
  const [cityRole, setCityRole] = useState('primary');
  const [language, setLanguage] = useState('');
  const [alliances, setAlliances] = useState([]);

  useEffect(() => {
    if (commander) {
      setName(commander.name);
      setRank(commander.rank);
      setBattlePower(commander.battlePower);
      setAlliance(commander.alliance ? (commander.alliance._id || commander.alliance) : '');
      setCityLevel(commander.cityLevel);
      setCityRole(commander.cityRole || 'primary');
      setLanguage(commander.language || '');
    }
  }, [commander]);

  useEffect(() => {
    const fetchAlliances = async () => {
      const nationId = getNationId(commander?.nation);
      if (!nationId) return;
      const response = await axios.get(`${apiUrl}/nations/${nationId}/alliances`);
      setAlliances(response.data);
    };
    if (isOpen) {
      fetchAlliances();
    }
  }, [axios, commander, isOpen]);

  const handleSave = async () => {
    const nationId = getNationId(commander?.nation);
    if (!nationId) {
      window.alert('Unable to determine nation for this commander.');
      return;
    }
    const updatedCommander = {
      ...commander,
      name,
      cityLevel,
      cityRole,
      language,
      rank,
      battlePower,
      alliance: alliance === "" ? null : alliance,
    };
    await axios.patch(`${apiUrl}/nations/${nationId}/commanders/${commander._id}`, updatedCommander);
    onCommanderUpdated();
    onRequestClose();
  };

  const handleBattlePowerChange = (e) => {
    // Remove any non-numeric characters (like commas) before storing the value
    const rawValue = e.target.value.replace(/\D/g, '');
    setBattlePower(rawValue);
  };

  const formatNumber = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Edit Commander"
      className="edit-commander-modal"
      overlayClassName="edit-commander-modal-overlay"
    >
      <h2>Edit Commander</h2>
      <label>
        Name:
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
      </label>
      <label>
        City Level:
        <input type="text" value={cityLevel} onChange={(e) => setCityLevel(e.target.value)} />
      </label>
      <label>
        City Role:
        <select value={cityRole} onChange={(e) => setCityRole(e.target.value)}>
          <option value="primary">Primary</option>
          <option value="secondary">Secondary</option>
          <option value="farm">Farm</option>
        </select>
      </label>
      <label>
        Rank:
        <input type="text" value={rank} onChange={(e) => setRank(e.target.value)} />
      </label>
      <label>
        Battle Power:
        <input type="text" value={formatNumber(battlePower)} onChange={handleBattlePowerChange} />
      </label>
      <label>
        Alliance:
        <select value={alliance} onChange={(e) => setAlliance(e.target.value)}>
          <option value="">None</option>
          {alliances.map((alliance) => (
            <option key={alliance._id} value={alliance._id}>
              {alliance.name} ({alliance.acronym})
            </option>
          ))}
        </select>
      </label>
      <label>
        Language:
        <input type="text" value={language} onChange={(e) => setLanguage(e.target.value)} />
      </label>
      <button onClick={handleSave}>Save</button>
      <button onClick={onRequestClose}>Cancel</button>
    </Modal>
  );
};

export default EditCommanderModal;
